import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import uploadZkjQnA from './uploadZkjQnA';

const ZupeeKheloJeetoDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.zupeeKheloJeeto}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadQnA]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/uploadQnA`}
				component={uploadZkjQnA}
				exact
			/>
			<Redirect to={`${path}/uploadQnA`} />
		</Switch>
	);
};

export default ZupeeKheloJeetoDashboard;
